// atorhome — header navigation behavior (markup: snippets/atorhome-header-menu.liquid, atorhome-header-drawer.liquid).
// Desktop dropdowns: open on hover (pointer devices) and on click; a click on a hover-opened panel pins it open.
// Close on outside click, Escape (focus returns to the toggle), or when focus leaves. ArrowDown on a toggle opens it
// and focuses the first link; ArrowUp/ArrowDown move between panel links.
// Drawer: the categories expand in place (aria-expanded + hidden). All handlers are delegated.
(function () {
  if (window.atorhomeHeader) return;
  window.atorhomeHeader = true;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const HOVER_CLOSE_DELAY = 200;
  let closeTimer;

  const dropdowns = () => document.querySelectorAll('[data-ah-dropdown]');
  const toggleOf = (item) => item.querySelector('.ah-nav__toggle');
  const isOpen = (item) => toggleOf(item).getAttribute('aria-expanded') === 'true';

  function setOpen(item, open, via) {
    const toggle = toggleOf(item);
    const panel = item.querySelector('.ah-nav__panel');
    if (!toggle || !panel) return;
    if (open) dropdowns().forEach((other) => other !== item && setOpen(other, false));
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    item.dataset.openedBy = open ? via : '';
  }

  function closeAll() {
    dropdowns().forEach((item) => isOpen(item) && setOpen(item, false));
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.ah-nav__toggle');
    if (toggle) {
      const item = toggle.closest('[data-ah-dropdown]');
      // A panel opened by hovering stays open on click (pinned) instead of closing under the pointer.
      if (isOpen(item) && item.dataset.openedBy === 'hover') item.dataset.openedBy = 'click';
      else setOpen(item, !isOpen(item), 'click');
      return;
    }
    if (!event.target.closest('[data-ah-dropdown]')) closeAll();

    const drawerToggle = event.target.closest('.ah-drawer-nav__toggle');
    if (drawerToggle) {
      event.preventDefault();
      toggleDrawerItem(drawerToggle);
    }
  });

  document.addEventListener('mouseover', (event) => {
    if (!canHover.matches) return;
    const item = event.target.closest('[data-ah-dropdown]');
    if (!item) return;
    clearTimeout(closeTimer);
    if (!isOpen(item)) setOpen(item, true, 'hover');
  });

  document.addEventListener('mouseout', (event) => {
    if (!canHover.matches) return;
    const item = event.target.closest('[data-ah-dropdown]');
    if (!item || item.contains(event.relatedTarget)) return;
    if (item.dataset.openedBy !== 'hover') return;
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => setOpen(item, false), HOVER_CLOSE_DELAY);
  });

  document.addEventListener('focusout', (event) => {
    const item = event.target.closest('[data-ah-dropdown]');
    if (item && isOpen(item) && event.relatedTarget && !item.contains(event.relatedTarget)) setOpen(item, false);
  });

  document.addEventListener('keydown', (event) => {
    const item = event.target.closest('[data-ah-dropdown]');

    if (event.key === 'Escape') {
      const open = item && isOpen(item) ? item : [...dropdowns()].find(isOpen);
      if (open) {
        setOpen(open, false);
        toggleOf(open).focus();
      }
      return;
    }

    if (item && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      const links = [...item.querySelectorAll('.ah-nav__panel a')];
      const index = links.indexOf(document.activeElement);
      if (event.target === toggleOf(item)) {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        setOpen(item, true, 'click');
        links[0]?.focus();
      } else if (index > -1) {
        event.preventDefault();
        const next = event.key === 'ArrowDown' ? index + 1 : index - 1;
        if (next < 0) toggleOf(item).focus();
        else links[Math.min(next, links.length - 1)].focus();
      }
      return;
    }

    // Drawer toggles are links with role="button": Space should toggle like a button.
    if (event.key === ' ' && event.target.matches('.ah-drawer-nav__toggle')) {
      event.preventDefault();
      toggleDrawerItem(event.target);
    }
  });

  function toggleDrawerItem(toggle) {
    const sub = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!sub) return;
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    sub.hidden = !open;
  }
})();
